import React from 'react'
import useDataLayer from 'src/hooks/useDataLayer/dataLayerBody'

import { Link } from 'gatsby'
import DefaultCarousel from 'src/components/UI/Carousels/DefaultCarousel'

import interProtectionPlatformJSON from './assets/data/data.json'

import Car from 'inter-frontend-svgs/lib/orangeds/MD/car'
import Credit from 'inter-frontend-svgs/lib/orangeds/MD/credit'
import Dollar from 'inter-frontend-svgs/lib/orangeds/MD/dollar'
import HouseFinancial from 'inter-frontend-svgs/lib/orangeds/MD/house-financial'
import Teeth from 'inter-frontend-svgs/lib/orangeds/MD/teeth'
import Travel from 'inter-frontend-svgs/lib/orangeds/MD/travel'

import { IconProps } from 'src/components/Layout/Footer/Footer.interface'

import { orange } from 'src/styles/colors'
import * as S from './style'

type ItemProps = {
  icon: string;
  title: string;
}

const InterSeguros = () => {
  const [ sendDatalayerEvent ] = useDataLayer()
  const icons: IconProps = {
    houseFinancial: <HouseFinancial color={orange.extra} width={40} height={40} />,
    credit: <Credit color={orange.extra} width={40} height={40} />,
    car: <Car color={orange.extra} width={40} height={40} />,
    dollar: <Dollar color={orange.extra} width={40} height={40} />,
    teeth: <Teeth color={orange.extra} width={40} height={40} />,
    travel: <Travel color={orange.extra} width={40} height={40} />,
  }

  return (
    <S.ContentHeader className='row content-tab align-items-center justify-content-center justify-content-lg-between mt-5 mt-md-0'>
      <div className='col-12 col-md-6 col-xl-5 justify-content-center'>
        <h3 className='fs-24 lh-30 fs-md-20 fs-lg-32 fs-xl-48 lh-lg-48 text-grayscale--500 font-sora fw-600'>
          Inter Seguros
        </h3>
        <p className='fs-16 fs-lg-18 lh-19 lh-lg-22 text-grayscale--400 fw-400'>
          Tem para a sua família, seu dinheiro e sua saúde. Mais de 1 milhão e 700 mil pessoas já estão protegidas com o Inter.
        </p>
        <div className='d-none d-md-block'>
          <Link
            to='/pra-voce/seguros/' title='Conhecer Seguros'
            className='btn btn-orange--extra rounded-2 fs-14 fw-600 text-none mt-2 mw-100'
            onClick={() => {
              sendDatalayerEvent({
                section: 'dobra_07',
                section_name: 'Mais que um banco digital, somos Inter!',
                element_action: 'click button',
                element_name: 'Conhecer Seguros - Inter Seguros',
              })
            }}
          >
            Conhecer Seguros
          </Link>
        </div>
      </div>
      <div className='col-12 col-md-6 col-lg-5 col-xl-6 offset-lg-1'>
        <DefaultCarousel
          customDotColor='#FF8700'
          sm={{ items: 1, partialVisibilityGutter: 30 }}
          md={{ items: 2 }}
          lg={{ items: 1, partialVisibilityGutter: 100 }}
          xl={{ items: 2, partialVisibilityGutter: 30 }}
        >
          {interProtectionPlatformJSON.map((item: ItemProps) => (
            <div key={item.title} className='mr-3'>
              <S.BoxWhiteCarousel className='d-flex flex-column justify-content-between'>
                <div>
                  {icons[item.icon]}
                </div>
                <div>
                  <p
                    className='font-citrina fs-20 lh-26 fs-md-16 lh-md-20 fs-lg-24 lh-lg-30 fw-600 text-grayscale--500 mb-0'
                    dangerouslySetInnerHTML={{ __html: item.title }}
                  />
                </div>
              </S.BoxWhiteCarousel>
            </div>
          ))}
        </DefaultCarousel>
        <a
          href='/pra-voce/seguros/' target='_blank' title='Conhecer Seguros'
          className='btn btn-orange--extra rounded-2 fs-14 fw-600 text-none mt-4 d-md-none'
          onClick={() => {
            sendDatalayerEvent({
              section: 'dobra_06',
              section_name: 'Mais que um banco digital, somos Inter!',
              element_action: 'click button',
              element_name: 'Conhecer Seguros - Inter Seguros',
            })
          }}
        >
          Conhecer Seguros
        </a>
      </div>
    </S.ContentHeader>
  )
}

export default InterSeguros
